import { NgModule } from 'angular-ts-decorators';

import { Language } from './services/language';
import { Softwear } from './services/softwear';
import { IsTestProvider } from './services/is-test';
import { TranslateProvider } from './services/translate';

require('../styles/module.css');

// dependencies
require('angular-cookie');
require('@schemas/schemas');
require('angular-moment');

import { classes } from './classes';
import { directives } from './directives';
import { components } from './components';
import { filters } from './filters';
import { services } from './services';
import { vendor } from './vendor';

/**
 * Main module of the application.
 */
@NgModule({
  id: 'sharedModule',
  declarations: directives.concat(filters, components),
  providers: services.concat(vendor, classes),
  imports: ['ipCookie', 'softwear.schemas', 'angularMoment'],
})
export class SharedModule {
  /* eslint-disable angular/di-unused, @typescript-eslint/no-unused-vars */

  // Make sure that softwear service is created, and it's object is exposed
  // globally
  static run(language: Language, moment, softwear: Softwear) {
    'ngInject';

    // TODO add a moment config to force the beginning of the week to Monday
    moment.locale(language.current);

    language.observe((languageId) => {
      moment.locale(language.current);
    });
  }
}

let sharedModule = angular.module('sharedModule');

// Note! for constant or provider to be available in config stage, it has to be
// added manually
sharedModule.constant('isTest', IsTestProvider.useValue);
sharedModule.provider('translate', TranslateProvider);

const { addDirectives } = require('./directives/no-decorators');

addDirectives(sharedModule);
